let _ = require('../_.js');
let $ = jQuery;



// Auctioncast player javascript interface.


// *** This file is a mess and needs a rewrite.  I didn't know what direction to go while I was writing it so 
//     everything is kind of spaghetti.  Thankfully all one really needs to know is:
//
//     these are registerable callback events for various states of auctioncast:
//
//     on_auctioncast_experience_started() / on_auctioncast_started() / on_auctioncast_stopped() / 
//     on_auctioncast_experience_stopped() / on_auctioncast_status 

// -- Old, and horribly out of date, documentation follows: --

// While only a single tenant application today (May 2023) it is designed to be multi tenant.

// When writing your theme, you have the ability to interact with auctioncast.  To place auctioncast
// on your page, create a div element called "#ac-gallery-auctioncast-container", make it visible, and call
// _.AuctionCast_AuctionCast.update_ui().  This will move the video player into this div.

// The following methods are available and intended for 3rd party use:

// on_auctioncast_started(callback)  - calls callback when stream has started
// on_auctioncast_stopped(callback)  - calls callback when stream has ended
// on_auctioncast_status(callback)   - calls callback when stream status has been updated
// on_footer_clicked(callback)       - calls callback when footer is clicked on the target auctioncast page.  page should scroll to video component.
// is_live()                         - returns true if auctioncast is in a 'playing' or 'initializing state' - basically, if it is shown.
// update_ui()                    - Reevaluates if the video stream should be in the footer or on the page
// get_auctioncast_url()             - Returns the URL of the current auctioncast property.  Null on information not available
// is_target_auctioncast_page()      - Returns true if the current page appears to be the correct URL for the auctioncast auction.  Null on information not available
// _.AuctionCast_AuctionCast.is_live()

import auctioncastHTML from './auctioncast.html?raw';

let auctioncastIframeHTML = '<iframe id="auctioncast_player_element" style="width: 100%; height: 100%;" src="https://ant.landproz.com:5443/auctioncast/play.html?id=live&playOrder=webrtc" frameborder="0" allowfullscreen></iframe>'

_.AuctionCast_AuctionCast = class AuctionCast_AuctionCast {

    static STATE_OFFLINE = 0;
    static STATE_STANDBY_PIP = 1;    // Pip player visible with a placeholder overlay
    static STATE_STANDBY_MAIN = 2;   // Pip player visible with iframe of live stream
    static STATE_LIVE_PIP = 3;       // Main player visible with a placeholder overlay
    static STATE_LIVE_MAIN = 4;      // Main player visible with iframe of live stream

    // Depending on state transitions, we will send these messages to the other classes to update their UI.
    static OPERATION_SHOW_MAIN_PLAYER = 0;   // Starting from nothing, create an auctioncast player in the MAIN element.
    static OPERATION_SHOW_PIP_PLAYER = 1;    // Starting from nothing, create an auctioncast player in the PIP element.
    static OPERATION_REMOVE_MAIN_PLAYER = 2; // Remove player from the MAIN element.
    static OPERATION_REMOVE_PIP_PLAYER = 3;  // Remove player from the PIP element.
    static OPERATION_TRANSITION_PIP_TO_MAIN_PLAYER = 4;  // Move player from the PIP element to MAIN element, continue video playback.
    static OPERATION_TRANSITION_MAIN_TO_PIP_PLAYER = 5;  // Move player from the MAIN element to PIP element, continue video playback.
    static OPERATION_SHOW_THIS_AUCTION_AUCTIONCAST_UI = 6; // We are currently on an auction with an active auctioncast stream, reveal the button for it.
    static OPERATION_HIDE_THIS_AUCTION_AUCTIONCAST_UI = 7; // This auction's auctioncast stream has stopped, remove the button for it.  Choose gallery if auctioncast was picked.
    static OPERATION_DISPLAY_OVERLAY = 8;    // The auction is in a standby state, mute / stop / hide the video stream and replace it with an overlay.
    static OPERATION_DISPLAY_LIVE = 9;       // The auction is in a live state, if there is an overlay remove it.  Start the video stream.  It should be unmuted if it was previously unmuted.
    static OPERATION_SELECT_MAIN_PLAYER_SHOW = 10;  // The auctioncast stream goes to this auction and just started, change the gallery view to show the auctioncast player.
    static OPERATION_CLICKED_OVERLAY = 11;  // The auctioncast stream goes to this auction and just started, change the gallery view to show the auctioncast player.

    static current_state = 0;

    static auctioncast_state_change_callbacks = [];
    static auctioncast_ui_operation_callbacks = [];
    static auctioncast_iframe_message_callbacks = [];
    static status_data = null;
    static has_shown_gallery_ui_this_stream = false;
    static has_force_shown_player_this_stream = false;
    static has_shown_live_player = false;
    static is_this_auction = false; // set to true if we are on the auction's page.  for use for other classes to access.

    static sendMessageQueue = [];
    static sendMessageAllowed = false;
    static bigPlayerOutOfFrame = false;

    static did_tell_frame_browser_is_mobile = false;
    static what_last_told_frame_is_this_auction = null;

    static already_executed_operations = [];

    // ---- Public interface to auctioncast by other modules ----

    // Register callback for auctioncast state change.
    // callback will take two arguments, old_status and new_status.
    static on_auctioncast_state_change(callback) {
        let that = _.AuctionCast_AuctionCast;
        that.auctioncast_state_change_callbacks.push(callback);
        callback(null, _.AuctionCast_AuctionCast.current_state);
    }

    // Register callback for auctioncast state change.
    // callback will take two arguments, old_status and new_status.
    static on_auctioncast_ui_operation(callback) {
        let that = _.AuctionCast_AuctionCast;
        that.auctioncast_ui_operation_callbacks.push(callback);

        (async function () {
            for (let o of _.AuctionCast_AuctionCast.already_executed_operations) {
                await callback(o);
            }
        })();
    }

    static is_active() {
        return false;
    }

    static is_pip() {
        return false;
    }

    static is_main() {
        return false;
    }

    static is_standby() {
        return false;
    }

    static is_live() {
        return false;
    }

    // This gets called by other classes after UI elements have changed.  For example,
    // if the user presses a button to see the gallery instead of the auctioncast on a live auction,
    // this module will want to move the player from MAIN to PIP.
    static refresh() {
        return false;
    }

    // Send a message to the iframe.
    // Messages accepted:
    // stop
    // play
    // overlay_should_unmute
    // overlay_should_mute
    // overlay_hide
    // overlay_show
    // overlay_hide_mute_button
    // overlay_show_mute_button
    // is_desktop
    // is_mobile
    static send_message_player_frame(message) {
        let that = _.AuctionCast_AuctionCast;

        if (message == "signal_ok_send_messages") {
            that.sendMessageAllowed = true;
        }

        let iframe = document.getElementById("auctioncast_player_element");

        if (iframe && iframe.contentWindow && that.sendMessageAllowed) {
            // Send all messages in the queue before sending the current message
            while (that.sendMessageQueue.length > 0) {
                let queuedMessage = that.sendMessageQueue.shift();
                iframe.contentWindow.postMessage(queuedMessage, "*");
            }
            // Send the current message
            iframe.contentWindow.postMessage(message, "*");
        } else {
            // Add the message to the queue if the iframe is not ready
            that.sendMessageQueue.push(message + "");
        }
    }

    // Register callbacks to receive messages from the iframe
    // The only two messages are:
    // - auctioncast_overlay_clicked
    // - auctioncast_player_ready
    static on_receive_message_auctioncast_player_frame(callback) {
        let that = _.AuctionCast_AuctionCast;
        that.auctioncast_iframe_message_callbacks.push(callback);
    }

    // Start it all up, register realtime updates
    static async init() {
        let that = _.AuctionCast_AuctionCast;

        // This is the player container that will either host an overlay or the iframe for the player.
        $("body").append(auctioncastHTML.replace(/__PLUGIN__/g, _.plugin_base_url()));

        // Register ui operation callbacks handled in this class
        // Other classes may also register, most notably gallery
        that.on_auctioncast_ui_operation(that.handle_auctioncast_ui_operation);

        // We can't change where the player is in the dom without stopping playback.
        // To get around this we are floating the player on the page.
        // We need to be extra diligent about repositioning it as a result.
        //Setup hooks for repositioning player

        $(window).resize(_.AuctionCast_AuctionCast.on_resize); // Will happen right away
        _.on_ui_resize(_.AuctionCast_AuctionCast.on_resize); // This covers some cases where resize is triggered manually
        $(window).scroll(_.AuctionCast_AuctionCast.on_resize); // Just in case
        _.on_ui_update_always(null, _.AuctionCast_AuctionCast.on_resize);

        // Add listener for iframe messages
        window.addEventListener('message', function (event) {
            // Check the origin of the data for security purposes
            if (event.origin === 'https://ant.landproz.com:5443') {
                if (event.data == 'auctioncast_player_ready') {
                    that.send_message_player_frame('signal_ok_send_messages');
                }
                for (let i in that.auctioncast_iframe_message_callbacks) {
                    that.auctioncast_iframe_message_callbacks[i](event.data);
                }
            }
        });

        $(window).scroll(_.AuctionCast_AuctionCast._big_player_in_frame_check);
    }

    // Called from gallery loaded, loads auctioncast.  This being done out of order is a hack because
    // i have had some race condition issues with the gallery.
    static async start_listening_for_updates() {
        console.log("Auctioncast: start_listening_for_updates");

        // Debug helper
        _.__start_listening_for_updates_did_start = true;

        let that = _.AuctionCast_AuctionCast;

        // The WS server pushes the stream status on subscribe and whenever it changes (one PHP
        // lookup per change for every page, instead of each page POSTing client-status). Re-sent on
        // every reconnect.
        _.on_websocket_receive(function (topic, data) {
            if (topic == "auctioncast_status") {
                _.AuctionCast_AuctionCast.status_data = data.auctioncast_status || null;
                _.AuctionCast_AuctionCast.stream_status_refresh();
            }
        });
        _.websocket_send_subscribe("auctioncast_status_subscribe", {});
    }


    static async stream_status_refresh() {
        await _.mutex('ac_stream_status_refresh', async function () {
            let that = _.AuctionCast_AuctionCast;
            // _status_data.auctioncast_status can be:
            // (null) - no stream
            // an AuctionCast record object.  This record has relevant properties:
            // - auction_id - id of the auction that the stream is associaed to
            // - is_ready   - the stream is functioning
            // - is_standby - the UI should reflect that the stream is active, but put an overlay in place of the stream
            // - is_live    - the stream is transmitting

            // If is_ready = false and is_live = true, the stream is an error state - it should be live but the stream isn't working.
            //              // For this, we can show the standby overlay.  We may want a 'technical difficulties' style overlay later, idk.

            let new_state = _.AuctionCast_AuctionCast.STATE_OFFLINE;
            let status_data = _.AuctionCast_AuctionCast.status_data;
            _.AuctionCast_AuctionCast.is_this_auction = false;             // True if we are looking at the page for the associated auction

            // Do not load auctioncast if going through cachewarming
            if (_.is_cachewarmer()) {
                return false;
            }

            if (status_data) {
                if (status_data.is_standby) {
                    new_state = _.AuctionCast_AuctionCast.STATE_STANDBY_PIP;
                } else if (status_data.is_live && !status_data.is_ready) {
                    new_state = _.AuctionCast_AuctionCast.STATE_STANDBY_PIP;
                } else if (status_data.is_live && status_data.is_ready) {
                    new_state = _.AuctionCast_AuctionCast.STATE_LIVE_PIP;
                }
            }

            if (status_data && new_state != _.AuctionCast_AuctionCast.STATE_OFFLINE) {
                if (_.ac_state && _.ac_state.auction && _.ac_state.auction.id == status_data.auction_id) {
                    _.AuctionCast_AuctionCast.is_this_auction = true;
                }

                if (_.AuctionCast_AuctionCast.is_this_auction) {
                    // Check: Is the player in view?  
                    // If not, show it in pip.  If this is a mobile phone, always consider it in view, don't show pip.
                    if ($(".ac-gallery-auctioncast-container").is(":visible")) {
                        if (new_state == _.AuctionCast_AuctionCast.STATE_STANDBY_PIP) {
                            new_state = _.AuctionCast_AuctionCast.STATE_STANDBY_MAIN;
                        }
                        if (new_state == _.AuctionCast_AuctionCast.STATE_LIVE_PIP) {
                            new_state = _.AuctionCast_AuctionCast.STATE_LIVE_MAIN;
                        }
                    }
                }
            }

            // Check for special exception of show pip on scroll on live auction page
            _.AuctionCast_AuctionCast._big_player_in_frame_check();

            // If this is true, its a special exception that conditions are right for PIP.
            if (_.AuctionCast_AuctionCast.bigPlayerOutOfFrame) {
                if (new_state == _.AuctionCast_AuctionCast.STATE_LIVE_MAIN) {
                    new_state = _.AuctionCast_AuctionCast.STATE_LIVE_PIP;
                }
            }

            // if (new_state == _.AuctionCast_AuctionCast.current_state) {
            //     // No action necessary.  End processing.
            //     console.log("NO CHANGE", new_state)
            //     return;
            // }

            //  --- THE STATE HAS CHANGED ---

            let old_state = _.AuctionCast_AuctionCast.current_state;
            _.AuctionCast_AuctionCast.current_state = new_state;

            // Handle UI changes / transitions

            if (old_state == _.AuctionCast_AuctionCast.STATE_OFFLINE && new_state != _.AuctionCast_AuctionCast.STATE_OFFLINE) {
                // Transition from nothing to something showing
                if (new_state == _.AuctionCast_AuctionCast.STATE_STANDBY_MAIN || new_state == _.AuctionCast_AuctionCast.STATE_LIVE_MAIN) {
                    await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_SHOW_MAIN_PLAYER);
                }
                if (new_state == _.AuctionCast_AuctionCast.STATE_STANDBY_PIP || new_state == _.AuctionCast_AuctionCast.STATE_LIVE_PIP) {
                    await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_SHOW_PIP_PLAYER);
                }
            } else if (old_state != _.AuctionCast_AuctionCast.STATE_OFFLINE && new_state == _.AuctionCast_AuctionCast.STATE_OFFLINE) {
                // Transition from something showing to nothing
                if (old_state == _.AuctionCast_AuctionCast.STATE_STANDBY_MAIN || old_state == _.AuctionCast_AuctionCast.STATE_LIVE_MAIN) {
                    await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_REMOVE_MAIN_PLAYER);
                }
                if (old_state == _.AuctionCast_AuctionCast.STATE_STANDBY_PIP || old_state == _.AuctionCast_AuctionCast.STATE_LIVE_PIP) {
                    await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_REMOVE_PIP_PLAYER);
                }
            } else if ((old_state == _.AuctionCast_AuctionCast.STATE_STANDBY_MAIN || old_state == _.AuctionCast_AuctionCast.STATE_LIVE_MAIN) &&
                // Transition from main to pip
                (new_state == _.AuctionCast_AuctionCast.STATE_STANDBY_PIP || new_state == _.AuctionCast_AuctionCast.STATE_LIVE_PIP)) {
                await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_TRANSITION_MAIN_TO_PIP_PLAYER);
            } else if ((old_state == _.AuctionCast_AuctionCast.STATE_STANDBY_PIP || old_state == _.AuctionCast_AuctionCast.STATE_LIVE_PIP) &&
                // Transition from pip to main
                (new_state == _.AuctionCast_AuctionCast.STATE_STANDBY_MAIN || new_state == _.AuctionCast_AuctionCast.STATE_LIVE_MAIN)) {
                await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_TRANSITION_PIP_TO_MAIN_PLAYER);
            }

            if (_.AuctionCast_AuctionCast.is_this_auction && new_state != _.AuctionCast_AuctionCast.STATE_OFFLINE && !_.AuctionCast_AuctionCast.has_shown_gallery_ui_this_stream) {
                // Show auction stream UI 
                _.AuctionCast_AuctionCast.has_shown_gallery_ui_this_stream = true;
                await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_SHOW_THIS_AUCTION_AUCTIONCAST_UI);
            }

            if (_.AuctionCast_AuctionCast.has_shown_gallery_ui_this_stream && (!_.AuctionCast_AuctionCast.is_this_auction || new_state == _.AuctionCast_AuctionCast.STATE_OFFLINE)) {
                // Hide auction stream UI 
                _.AuctionCast_AuctionCast.has_shown_gallery_ui_this_stream = false;
                await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_HIDE_THIS_AUCTION_AUCTIONCAST_UI);
            }

            if (_.AuctionCast_AuctionCast.has_shown_gallery_ui_this_stream && !_.AuctionCast_AuctionCast.has_force_shown_player_this_stream && status_data.is_live && _.AuctionCast_AuctionCast.is_this_auction) {
                // Force show player, stream has started and it is this auction.  Only do this once per stream.
                _.AuctionCast_AuctionCast.has_force_shown_player_this_stream = true;
                await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_SELECT_MAIN_PLAYER_SHOW);
            }

            if ((old_state == _.AuctionCast_AuctionCast.STATE_OFFLINE || old_state == _.AuctionCast_AuctionCast.STATE_STANDBY_PIP || old_state == _.AuctionCast_AuctionCast.STATE_STANDBY_MAIN) &&
                (new_state == _.AuctionCast_AuctionCast.STATE_LIVE_PIP || new_state == _.AuctionCast_AuctionCast.STATE_LIVE_MAIN)) {
                // Transition video player from nothing / overlay to live
                await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_DISPLAY_LIVE);

            } else if ((old_state == _.AuctionCast_AuctionCast.STATE_OFFLINE || old_state == _.AuctionCast_AuctionCast.STATE_LIVE_PIP || old_state == _.AuctionCast_AuctionCast.STATE_LIVE_MAIN) &&
                (new_state == _.AuctionCast_AuctionCast.STATE_STANDBY_PIP || new_state == _.AuctionCast_AuctionCast.STATE_STANDBY_MAIN)) {
                // Transition video player from nothing / live to overlay
                await _.AuctionCast_AuctionCast._emit_ui_operation(_.AuctionCast_AuctionCast.OPERATION_DISPLAY_OVERLAY);
            }

            // Set new state on class property.
            // Call status change callbacks for operations that have requirements that don't fit the above callbacks.

            // Create the player if necessary.
            if (!_.AuctionCast_AuctionCast.has_shown_live_player && (new_state == _.AuctionCast_AuctionCast.STATE_LIVE_PIP || new_state == _.AuctionCast_AuctionCast.STATE_LIVE_MAIN)) {
                _.AuctionCast_AuctionCast.has_shown_live_player = true;
                let $player_container = $('.auctioncast-video-container');

                $player_container.append($(auctioncastIframeHTML));
            }

            // Update the frame with is_this_auction
            if (_.AuctionCast_AuctionCast.what_last_told_frame_is_this_auction != _.AuctionCast_AuctionCast.is_this_auction) {
                if (_.AuctionCast_AuctionCast.is_this_auction) {
                    that.send_message_player_frame('hide_live_indicator');
                } else {
                    that.send_message_player_frame('show_live_indicator');
                }
                _.AuctionCast_AuctionCast.what_last_told_frame_is_this_auction = _.AuctionCast_AuctionCast.is_this_auction;
            }

            await _.AuctionCast_AuctionCast._emit_status_change(old_state, new_state);
        });
    }

    static async _emit_ui_operation(operation) {
        let that = _.AuctionCast_AuctionCast;
        console.log("Emit AuctionCast UI operation ", operation);
        _.AuctionCast_AuctionCast.already_executed_operations.push(operation);
        for (let i in that.auctioncast_ui_operation_callbacks) {
            await that.auctioncast_ui_operation_callbacks[i](operation);
        }
    }

    static async _emit_status_change(old_state, new_state) {
        let that = _.AuctionCast_AuctionCast;
        // console.log("Emit AuctionCast status change ", old_state, new_state);
        for (let i in that.auctioncast_state_change_callbacks) {
            await that.auctioncast_state_change_callbacks[i](old_state, new_state);
        }
    }

    // Handle Auctioncast UI operations that have to do with the player element itself, and not where it is positioned.
    static async handle_auctioncast_ui_operation(operation) {

        let $player_container = $('.auctioncast-video-container');

        switch (operation) {
            case _.AuctionCast_AuctionCast.OPERATION_SHOW_MAIN_PLAYER:
            case _.AuctionCast_AuctionCast.OPERATION_SHOW_PIP_PLAYER:
                $player_container.show();
                if (!$("#auctioncast_standby_overlay_element").length) {
                    // Create a overlay element in $player_container
                    $player_container.append($('<div id="auctioncast_standby_overlay_element" style="display: none; width: 100%; height: 100%; border: 2px solid black; background-image: url(/wp-content/themes/landproz/img/ac_large.jpg); background-size: cover; background-position: center;"></div>'));
                }
                $(".auctioncast-video-container").show();
                break;

            case _.AuctionCast_AuctionCast.OPERATION_REMOVE_MAIN_PLAYER:
            case _.AuctionCast_AuctionCast.OPERATION_REMOVE_PIP_PLAYER:
                // Destroy player elements
                _.AuctionCast_AuctionCast.has_shown_live_player = false;
                $player_container.empty();
                $(".auctioncast-video-container").hide();
                break;

            case _.AuctionCast_AuctionCast.OPERATION_DISPLAY_OVERLAY:
                // Swap to overlay (default is none)
                // Player should be hidden and muted, but can be restored later.

                $("#auctioncast_player_element").hide();
                $(".auctioncast-video-container").show();
                $("#auctioncast_standby_overlay_element").show();
                _.AuctionCast_AuctionCast.send_message_player_frame('stop');
                break;

            case _.AuctionCast_AuctionCast.OPERATION_DISPLAY_LIVE:
                // Swap to live (default is none)

                $("#auctioncast_player_element").show();
                $(".auctioncast-video-container").show();
                $("#auctioncast_standby_overlay_element").hide();
                _.AuctionCast_AuctionCast.send_message_player_frame('play');
                break;
        }
    }

    static _$target_element = null;
    static _$target_is_fixed = false;

    static async set_player_target_element($element, target_is_fixed) {
        let $player_container = $('.auctioncast-video-container, .auctioncast-player-nav-overlay');

        _.AuctionCast_AuctionCast._$target_element = $element;
        _.AuctionCast_AuctionCast._$target_is_fixed = !!target_is_fixed;
        $player_container.css('position', 'fixed');

        _.AuctionCast_AuctionCast.on_resize();
    }

    static on_resize() {

        let that = _.AuctionCast_AuctionCast;

        let $player_container = $('.auctioncast-video-container, .auctioncast-player-nav-overlay');

        // The $target_element must be defined to position the player container
        if (!_.AuctionCast_AuctionCast._$target_element) {
            return;
        }

        let $target = _.AuctionCast_AuctionCast._$target_element;

        // Use position:fixed + getBoundingClientRect() for positioning.
        // The overlay is appended to <body> which has position:relative (_resets.scss)
        // and zoom:0.85 on viewports <= 420px (stray.scss). The zoom causes CSS pixel
        // values to be scaled, so top/left must be divided by the zoom factor.
        // outerWidth/outerHeight are already in layout CSS pixels and scale correctly.
        let targetRect = $target[0].getBoundingClientRect();
        let bodyZoom = parseFloat(getComputedStyle(document.body).zoom) || 1;

        let cssSettings = {
            position: 'fixed',
            top: targetRect.top / bodyZoom,
            left: targetRect.left / bodyZoom,
            width: $target.outerWidth(),
            height: $target.outerHeight()
        };

        $player_container.css(cssSettings);

        if ((_.isMobileViewport() || _.isMobileUserAgent())) {
            that.send_message_player_frame('is_mobile');
            that.did_tell_frame_browser_is_mobile = true;
            $(".pip-container").addClass('pip-container-is-mobile');
        } else if (!(_.isMobileViewport() || _.isMobileUserAgent())) {
            that.send_message_player_frame('is_desktop');
            that.did_tell_frame_browser_is_mobile = false;
            $(".pip-container").removeClass('pip-container-is-mobile');
        }
    }

    // If auctioncast video is playing, mute it.
    static mute() {
        _.AuctionCast_AuctionCast.send_message_player_frame('mute');
    }

    // Seperation of concerns exception here.  
    // This is a special condition, if we are on the auction page for the auctioncast, and the auctioncast
    // player is picked in the gallery, if the player window is not visible, then we will show the pip player.
    static _big_player_in_frame_check() {
        _.mutex('_big_player_in_frame_check', async function () {
            try {
                function _isElementSortOfInViewport(el) {
                    try {
                        var rect = el.getBoundingClientRect();
                        let windowHeight = window.innerHeight || document.documentElement.clientHeight;
                        return ((rect.top >= 0 && rect.top <= windowHeight - 20) || (rect.bottom >= 0 && rect.bottom <= windowHeight));
                    } catch (e) {
                        return false;
                    }
                }
                let old_value = _.AuctionCast_AuctionCast.bigPlayerOutOfFrame;
                if ($(".ac-gallery-auctioncast-container").is(":visible")) {
                    if (_isElementSortOfInViewport($(".ac-gallery-auctioncast-container")[0])) {
                        _.AuctionCast_AuctionCast.bigPlayerOutOfFrame = false;
                    } else {
                        _.AuctionCast_AuctionCast.bigPlayerOutOfFrame = true;
                    }
                } else {
                    _.AuctionCast_AuctionCast.bigPlayerOutOfFrame = false;
                }
                if (old_value != _.AuctionCast_AuctionCast.bigPlayerOutOfFrame) {
                    await _.AuctionCast_AuctionCast.stream_status_refresh();
                }
            } catch (e) {
                // Noting for now
            }
        });
    }

}


